module.exports = __webpack_public_path__ + "static/media/snow.a17699a6.png";